import React, { useState, useEffect } from 'react';
import useSignUpManager from '../../useSignUpManager';
import ManualSignUpSection from './ManualSignUpSection';
import SignUpMethodSection from './SignUpMethodSection';
import EmailVerificationPage from '../../EmailVerificationPage/EmailVerificationPage';

const SignUpForm: React.FC = () => {
    const signUpManager = useSignUpManager();

    const [displayManualSignUp, setDisplayManualSignUp] = useState(false);
    const [showEmailVerification, setShowEmailVerification] = useState(false);
    const [userEmail, setUserEmail] = useState('');

    useEffect(() => {
        signUpManager.setRedirectUrlAfterPasswordReset(`${window.location.origin}/deals`);
    }, [signUpManager.setRedirectUrlAfterPasswordReset]);

    const handleSignUpSuccess = (email: string) => {
        setUserEmail(email);
        if (!signUpManager.socialSignUpConnectionType) {
            setShowEmailVerification(true);
        }
    };

    const handleBackFromVerification = () => {
        setShowEmailVerification(false);
        setDisplayManualSignUp(false);
        setUserEmail('');
    };

    const renderContent = () => {
        if (showEmailVerification) {
            return <EmailVerificationPage email={userEmail} onBack={handleBackFromVerification} />;
        }
        if (!displayManualSignUp) {
            return (
                <SignUpMethodSection
                    onClickManualSignUp={() => setDisplayManualSignUp(true)}
                    signUpManager={signUpManager}
                />
            );
        }
        return (
            <ManualSignUpSection
                onBack={() => setDisplayManualSignUp(false)}
                signUpManager={signUpManager}
                userOrgLookupData={signUpManager.userOrgLookupData}
                onSignUpSuccess={handleSignUpSuccess}
            />
        );
    };

    return (
        <form className="DirectSignUp__Form">
            <h1 className="DirectSignUp__Heading">Sign up.</h1>
            {renderContent()}
        </form>
    );
};

export default SignUpForm;
